import { render, staticRenderFns } from "./AdminWorklist.vue?vue&type=template&id=845b477e&scoped=true"
import script from "./AdminWorklist.vue?vue&type=script&lang=js"
export * from "./AdminWorklist.vue?vue&type=script&lang=js"
import style0 from "./AdminWorklist.vue?vue&type=style&index=0&id=845b477e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845b477e",
  null
  
)

export default component.exports